var _mask, _g, _g2, _path, _circle, _circle2, _g3, _g4, _path2, _g5, _g6, _g7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBottts1767950119631(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 180 180",
    fill: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "viewboxMask"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 180,
    height: 180,
    rx: 0,
    ry: 0,
    x: 0,
    y: 0,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#viewboxMask)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 66)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "sidesAntenna01-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 6,
    y: 11,
    width: 156,
    height: 51
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 31,
    width: 36,
    height: 14,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 14,
    width: 36,
    height: 48,
    rx: 4
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126,
    y: 28,
    width: 36,
    height: 24,
    rx: 4
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11h2v20h-2z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#sidesAntenna01-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h180v76H0V0Z",
    fill: "#546e7a"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.3,
    d: "M0 0h180v76H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M0 38h180v38H0z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.4,
    d: "M11 11h2v20h-2z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 8,
    r: 4,
    fill: "#FFEA8F"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 7,
    r: 2,
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(41)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "topLights-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 10,
    y: 22,
    width: 80,
    height: 30
  }, _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 42c0-1.1.9-2 2-2h76a2 2 0 0 1 2 2v10H10V42Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 27a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v25H18V27ZM42 27a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v25H42V27ZM66 27a5 5 0 0 1 5-5h6a5 5 0 0 1 5 5v25H66V27Z"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#topLights-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#546e7a"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h100v52H0V0Z",
    fill: "#fff",
    fillOpacity: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0.6,
    d: "M0 0h100v40H0z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72,
    y: 28,
    width: 4,
    height: 8,
    rx: 2,
    fill: "#fff",
    fillOpacity: 0.6
  })))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(25 44)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "faceRound01-a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 130,
    height: 120
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M66 0c58.35 0 64 40.69 64 78 0 33.31-25.47 42-64 42-37.46 0-66-8.69-66-42C0 40.69 7.65 0 66 0Z",
    fill: "#fff"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#faceRound01-a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4-2h138v124H-4V-2Z",
    fill: "#546e7a"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M27.3 65.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM35.7 69.41a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM35.7 82.03a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM35.7 94.66a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM34.1 109.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM49.2 107.1a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM27.3 90.45a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM29.2 101.1a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM51.1 103.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM42 88.34a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM39.9 103.07a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM29.4 75.72a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM39.9 77.83a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM10.5 94.66a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM8.4 84.14a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM10.5 107.28a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM2.1 90.45a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM4.2 100.97a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM14.7 90.45a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM16.8 100.97a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM8.4 71.52a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM4.2 75.72a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM14.7 65.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM16.8 75.72a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM21 96.76a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM23.1 82.03a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM21 109.38a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM35.7 119.9a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM27.3 115.69a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM42 113.59a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM8.4 122a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM4.2 113.59a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM14.7 115.69a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM23.1 119.9a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM21 71.52a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.3 4.2a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM125.7 8.41a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM125.7 21.03a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM125.7 33.66a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM123.6 48.38a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM119.4 27.34a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM117.3 42.07a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM132 27.34a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM129.9 42.07a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM119.4 14.72a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM129.9 16.83a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM100.5 33.66a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM98.4 23.14a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM100.5 46.28a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM92.1 29.45a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM106.8 27.34a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM104.7 42.07a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM100.5 8.41a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM92.1 16.83a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM106.8 2.1a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM104.7 16.83a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM113.1 33.66a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM111 23.14a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM113.1 46.28a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM123.6 61a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM132 52.59a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM104.7 54.69a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2ZM113.1 58.9a2.1 2.1 0 1 1-4.2 0 2.1 2.1 0 0 1 4.2 0ZM111 10.52a2.1 2.1 0 1 0 0-4.2 2.1 2.1 0 0 0 0 4.2Z",
    fillOpacity: 0.1
  })))))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(52 124)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 5,
    width: 68,
    height: 22,
    rx: 5,
    fill: "#000",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 9,
    width: 60,
    height: 14,
    rx: 2,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    fillOpacity: 0.1,
    d: "M18 9h4v14h-4zM42 9h4v14h-4zM30 9h4v14h-4zM54 9h4v14h-4z"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(38 76)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 4,
    width: 104,
    height: 42,
    rx: 4,
    fill: "#000",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 25,
    width: 10,
    height: 11,
    rx: 2,
    fill: "#8BDDFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 66,
    y: 25,
    width: 10,
    height: 11,
    rx: 2,
    fill: "#8BDDFF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4h8L12 46H4L21 4Z",
    fill: "#fff",
    fillOpacity: 0.4
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBottts1767950119631);
export default __webpack_public_path__ + "static/media/bottts-1767950119631.ed7514e0c543ab4ca8f0ab23ff9997b1.svg";
export { ForwardRef as ReactComponent };